import { makeStyles } from '@material-ui/core/styles';
import { backgroundRectangle, estilosTextosPrincipales, colores, buttonPrimarySmall, buttonSecundaryBig, tipografia } from '../../../AppStyle';

const useStyles = (isPhoneVersion) => {

    const style = makeStyles({
        backgroundRectangle: {
            ...backgroundRectangle,
            marginBottom: '0px',
            paddingLeft: '2%',
        },
        tituloPagina: {
            ...estilosTextosPrincipales.encabezadoH3,
            color: colores.escalaGrises.cien,
            fontWeight: 'bold',
        },
        hclassText2: {
            ...estilosTextosPrincipales.encabezadoH3,
            color: colores.escalaGrises.cien,
            fontWeight: 'bold',
            fontSize: '15px',
            paddingTop: '2%'
        },
        gridBoton: {
            width: '100%',
            paddingRight: '5%',
            ...(isPhoneVersion) && { paddingLeft: '5%', },
            margin: 0,
        },
        botonVolver: {
            ...buttonPrimarySmall,
            margin: '1% 0.5% 1% 1%',
            ...(isPhoneVersion) && { width: '100%', },
        },
        gridSubirArchivo: {
            paddingBottom: '2%',
            display: 'flex',
            flexWrap: 'wrap',
            gap: '16px',
            maxHeight: '400px',
            overflowY: 'auto',
        },
        botonFirma: {
            ...buttonSecundaryBig,
            margin: '1% 0.5% 1% 1%',
            ...(isPhoneVersion) && { width: '100%', },
        },
        classBackdrop: {
            zIndex: 1,
            color: '#fff',
        },
        gridTitulo: {
            display: 'flex',
            flexDirection: 'row',
            marginTop: '2%',
            marginLeft: '5%',
            width: '90%'
        },
        idExpediente: {
            marginLeft: '25px',
            color: colores.escalaGrises.sesenta,
            fontFamily: tipografia.bold,
            fontSize: '13px',
            height: 'inherit',
            display: 'flex',
            alignItems: 'center'
        }, 
        mensajeErrorFlotante: {
            position: 'fixed',
            bottom: '20px',
            left: '50%',
            transform: 'translateX(-50%)',
            backgroundColor: '#f44336',
            color: '#fff',
            padding: '12px 24px',
            borderRadius: '8px',
            boxShadow: '0 4px 6px rgba(0,0,0,0.3)',
            zIndex: 1300,
            fontSize: '0.95rem',
            animation: '$aparecer 0.3s ease-in-out',
        },
        '@keyframes aparecer': {
            from: { opacity: 0, transform: 'translateX(-50%) translateY(10px)' },
            to: { opacity: 1, transform: 'translateX(-50%) translateY(0)' },
        },
    });

    return { style }
}

export default useStyles;